module.exports = __webpack_public_path__ + "static/media/shape0_0.7e65d5c5.obj";